/* global jQuery */
( ( $ ) => {
	const initializeBlock = () => {
        
        
        const $id = $( '.homepage-solutions' );
        $( '.top-sol-tabs li:first-child .button' ).css('color', $id.data('icon-active-color'));
        $( '.top-sol-tabs li:first-child .button' ).addClass("active");
        $( '.top-sol-tabs li:first-child img' ).addClass("active");
        
        $(".top-sol-tabs ul.item-list li").attr( 'aria-selected', 'false' );
        $(".top-sol-tabs ul.item-list li:first-child").attr( 'aria-selected', 'true' );

        $( '.top-sol-tabs ul.item-list li' ).attr( 'tabindex', '0' );
        
		$( '.phr-sol-content' ).not( '.slick-initialized' ).slick( {
			dots: false,
			autoplay: false,
			speed: 1000,
            arrows: false,
			fade: true,
            infinite: false,
			waitForAnimate: false,
            adaptiveHeight: true,
            draggable: false,
            swipe: false,
            responsive: [
				{
					breakpoint: 1200,
					settings: {
						adaptiveHeight: true,
                        draggable: false,
                        swipe: false,
					},
				},

				{
					breakpoint: 768,
					settings: {
                        adaptiveHeight: true,
                        draggable: false,
                        swipe: false,
					},
				},
                
			],
		} );
        
        
        $( '.top-sol-tabs li' ).on( 'click keydown', ( event ) => {
            if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
                event.preventDefault();
            
            const thisButton = $( event.currentTarget).children(".button");
            const thisImg = $( event.currentTarget).children("img");
            
            $( '.top-sol-tabs li img' ).removeClass("active");
            $( '.top-sol-tabs li .button' ).removeClass("active");
            $( '.top-sol-tabs li .button' ).css('color', $id.data('icon-color'));
            $(".top-sol-tabs li").attr( 'aria-selected', 'false' );
            


            //$( '.top-sol-tabs .button' ).css('background-color', $id.data('icon-color'));
            thisButton.css('color', $id.data('icon-active-color'));
            thisImg.addClass("active");
            thisButton.addClass("active");
            $( event.currentTarget).attr( 'aria-selected', 'true' );
			const whichslide = thisButton.data( 'slide' );

			$( '.phr-sol-content' ).slick( 'slickGoTo', whichslide );
            
            
            const GAslide = ' Button - ' + (whichslide+1); 
            ga( 'send', 'event', 'Homepage Solutions Click', GAslide, document.title );
            
            window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'component_click',
                        'event_category': 'Homepage Solutions Click',
                        'event_label': GAslide,
                        'page_url': document.title
});
                    return false;

}
            
		} );

        $(".phr-sol-content").on("afterChange", function (){  
            

            //Accessibility fix so slide content stays in focus when using arrow keys to navigate
                if ($('.phr-sol-content .slick-slide:focus-within').length > 0) {
                setTimeout(function() { 
                    $(".phr-sol-content .slick-active").focus();
                }, 500);
            }
            
            $( '.top-sol-tabs li' ).each(function(){
                const thisButton = $(this).children(".button");
                const thisImg = $(this).children("img");
                
                const datavalue= thisButton.data( 'slide' );
                const currentSlide = $('.phr-sol-content').slick('slickCurrentSlide');
                const currentTab = currentSlide;

                if (datavalue == currentTab){
                    thisButton.css('color', $id.data('icon-active-color'));
                    thisImg.addClass("active");
                    thisButton.addClass("active");
                    $(this).attr( 'aria-selected', 'true' );
                }
                
                else {
                    thisButton.css('color', $id.data('icon-color'));
                    thisImg.removeClass("active");
                    thisButton.removeClass("active");
                    $(this).attr( 'aria-selected', 'false' );
                }
                    
                
            });
            
            
    });


	};
    

	// Initialize each block on page load (front end).
	$( document ).ready( () => {
		initializeBlock();

	} );

	// Initialize dynamic block preview (editor).
	if ( window.acf ) {
		window.acf.addAction( 'render_block_preview/type=homepage-solutions', initializeBlock );
	}
} )( jQuery );
